namespace GeniuzPOS.QRreport {
    export interface QRywcSpecSaleTaxForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DocMonth: Serenity.LookupEditor;
        DocYear: Serenity.DateYearEditor;
        ShopId: Serenity.LookupEditor;
    }

    export class QRywcSpecSaleTaxForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpecSaleTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecSaleTaxForm.init)  {
                QRywcSpecSaleTaxForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateYearEditor;

                Q.initFormType(QRywcSpecSaleTaxForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DocMonth', w0,
                    'DocYear', w3,
                    'ShopId', w0
                ]);
            }
        }
    }
}
